import moment from 'moment';

export function limitEventEndToStartDay(
    start: moment.Moment,
    end: moment.Moment
): moment.Moment {
    const startDayEnd = start.clone().endOf('day');
    return end.isAfter(startDayEnd) ? startDayEnd : end;
}
